import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ThLoading } from '@components/elements';
import { BASE_PATH } from '@utils/Environment';
import { buildLoginUrl } from '@utils/LoginUtils';

export default function LoginRedirect() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const explicitRedirect = new URLSearchParams(search).get('redirectUrl');
    // Fall back to the page they were on, unless that is the login route
    // itself, which would send them straight back here after logging in.
    const redirectPath =
      explicitRedirect ||
      (pathname === `${BASE_PATH}login` ? null : pathname + search);
    window.location.replace(buildLoginUrl(redirectPath));
  }, [pathname, search]);

  return <ThLoading />;
}
